import List from "@/components/list";
/*
 *  超级管理员可以修改readony=1的数据，其他角色不可以，有新增权限才可以操作
 */

const Table = (args) => {
  const { listeners, props } = args;
  const showScoreDialog = listeners["showScoreDialog"] || function() {};

  const TotalScore = ({ props: { vo } }) => {
    const item = vo.row;
    if (item.totalScore) {
      return (
        <span class="base-hover-char" onClick={() => showScoreDialog(item)}>
          {item.totalScore}
        </span>
      );
    } else {
      return <span>--</span>;
    }
  };
  const GeneralScore = ({ props: { vo } }) => {
    const item = vo.row;
    if (item.generalScore) {
      return (
        <span class="base-hover-char" onClick={() => showScoreDialog(item)}>
          {item.generalScore}
        </span>
      );
    } else {
      return <span onClick={() => showScoreDialog(item)}>--</span>;
    }
  };

  const AccountTableConfig = [
    {
      label: "培训名称",
      prop: "className",
      minWidth: "120",
    },
    {
      label: "培训周期",
      prop: "trainTime",
      minWidth: "100",
    },
    {
      label: "学时",
      prop: "trainHours",
      width: "80",
    },
    {
      label: "结业状态",
      prop: "graduationStatus",
      width: "80",
    },
    {
      label: "请假天数",
      prop: "leaveDays",
      width: "80",
    },
    {
      label: "主办单位",
      prop: "organizer",
      minWidth: "100",
    },
    {
      label: "承办单位",
      prop: "undertakeUnit",
      minWidth: "100",
    },
  ];
  if (args.props.isOnline == 0) {
    AccountTableConfig.splice(0, 0, {
      label: "培训类型",
      prop: "trainTypeName",
      width: "100",
    });
    AccountTableConfig.splice(3, 0, {
      label: "学制",
      prop: "trainDays",
      width: "80",
    });
    AccountTableConfig.push(
      {
        label: "学员数字画像",
        prop: "totalScore",
        width: "140",
        render: vo => <TotalScore vo={vo} />
      },
      // {
      //   label: "学员数字画像",
      //   prop: "generalScore",
      //   width: "140",
      //   render: (vo) => <GeneralScore vo={vo} />,
      // }
    );
  }

  return <List {...args} talbeCols={AccountTableConfig} />;
};

export default Table;
